module.exports = __webpack_public_path__ + "img/144ne.f99f9a8f.svg";